import { render } from "./PlayStyleIcon.vue?vue&type=template&id=5bc2c591&ts=true"
import script from "./PlayStyleIcon.vue?vue&type=script&lang=ts"
export * from "./PlayStyleIcon.vue?vue&type=script&lang=ts"

import "./PlayStyleIcon.vue?vue&type=style&index=0&id=5bc2c591&lang=css"

import exportComponent from "D:\\Users\\temari\\WebstormProjects\\iidx_viewer\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__